import en from 'constants/dropdownOptions/countries/en';
import es from 'constants/dropdownOptions/countries/es';
import pl from 'constants/dropdownOptions/countries/pl';

export const ALL_COUNTRIES_LANGUAGES_VERSIONS = [en, es, pl];
